import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "../../theme";
import { SegmentedControl } from "../../segmented-control";
import { useBlockComponentContext } from "../BlockComponentContext";
export const LanguageControls = ({ activeMutationIndex, mutations, onChange, }) => {
    const { translate } = useBlockComponentContext();
    return (_jsxs(Container, { children: [_jsx(Label, { children: "Choose language of video" }), _jsx(SegmentedControlWrapper, { children: _jsx(SegmentedControl, { selectedIndex: activeMutationIndex, segments: mutations.map(mutation => translate(mutation.language.label.translationKey)), onChange: onChange }) })] }));
};
const Container = styled.div `
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.media.md} {
    flex-direction: row;
    align-items: center;
    padding: 30px 0;
  }
`;
const Label = styled.label `
  font-size: 1.25em;
  padding: 10px 0;
`;
const SegmentedControlWrapper = styled.div `
  ${({ theme }) => theme.media.md} {
    margin-left: 20px;
    width: 10px;
    height: 50px;
  }
`;
